import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  activitiesRepository,
  type ActivityUpdatePayload,
} from "../repositories/activitiesRepository";
import { invalidateSupplyPlanQueries } from "./useSupplyPlanQuery";

export const useUpdateActivityMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: ActivityUpdatePayload) =>
      activitiesRepository.updateActivity(payload.id ?? "no-id", payload),
    onSuccess: (_response, variables) => {
      const scopedTerreiroId = variables.terreiroId;
      const scopedMediumId = variables.mediumId;

      queryClient.invalidateQueries({
        predicate: (query) => {
          const key = query.queryKey;
          if (!Array.isArray(key)) return false;

          if (scopedTerreiroId) {
            return (
              key[0] === "terreiro" &&
              key[1] === scopedTerreiroId &&
              (key[2] === "activities" || key[2] === "activity")
            );
          }

          if (scopedMediumId) {
            return (
              (key[0] === "activity" && key[1] === "medium" && key[2] === scopedMediumId) ||
              (key[0] === "personal" && key[1] === "activities" && key[2] === "recent")
            );
          }

          return false;
        },
      });

      invalidateSupplyPlanQueries(
        queryClient,
        scopedTerreiroId,
        scopedMediumId,
      );
    },
  });
};
